<template>
  <div class="page">
    <!-- 用户信息 -->
    <user-info :user-info="otherViewInfoVo" />

    <!-- 赛事指导 -->
    <img :src="$options.imgObj.guidance" alt="赛事指导" class="guidance" @click="guidance" />

    <div class="content-box">
      <div class="name">
        <div class="name-content">
          <p class="production-name">《{{ otherViewInfoVo.workName }}》</p>
          <p class="school-name">{{ otherViewInfoVo.schoolName }}</p>
        </div>
      </div>
      <div class="content">
        <div class="prod">
          <div class="prod-no">
            参赛编号:{{ otherViewInfoVo.competitionNo ? otherViewInfoVo.competitionNo : '--' }}
          </div>
          <img :src="otherViewInfoVo.workUrl" alt="" />
        </div>

        <div class="rank">
          <div class="rank-item">
            <p class="rank-value">{{ otherViewInfoVo.rank | formatRank }}</p>
            <p class="rank-title">个人人气榜</p>
          </div>
          <div class="rank-item">
            <p class="rank-value">{{ otherViewInfoVo.likeNum }}</p>
            <p class="rank-title">人气值</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="basicData.state === 1">
      <div class="video">
        <img :src="$options.imgObj.videoBg" alt="" class="video-bg" />
        <video-player
          v-if="otherViewInfoVo.video"
          class="fancy_video"
          :video-url="'/static' + otherViewInfoVo.video"
          :cover-url="require('paintingCompetition/assets/home/videoCover.png')"
        />
      </div>
      <div class="to-home">
        <rules :auto-display="autoDisplay" ref="rule" @click.stop="onShow" />
      </div>
    </div>
    <div class="btn">
      <img :src="$options.imgObj.btn4" alt="" class="btn4" @click="addPopular" />
      <img :src="$options.imgObj.showLike" alt="点赞动画" class="show_like" v-if="showLike" />
    </div>

    <!-- 限时抢课弹窗 -->
    <purchase-course :show="showPurchaseCourse"></purchase-course>

    <!-- 参赛弹窗 -->
    <join-competition :show.sync="showJoinCompetition"></join-competition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserInfo from 'paintingCompetition/components/UserInfo/index.vue'
import PurchaseCourse from 'paintingCompetition/components/Popup/PurchaseCourse'
import JoinCompetition from 'paintingCompetition/components/Popup/JoinCompetition'
import { getPersonIndex, giveLike } from 'paintingCompetition/api'
import {
  COMPETITION_GUIDE_ROUTE,
  PERSON_INFO_ROUTE,
  ACTIVITY_TYPE,
  HOME_ROUTE
} from 'paintingCompetition/constant'
import VideoPlayer from 'paintingCompetition/components/VideoPlayer'
import Rules from '../home/header/rules/index.vue'
import AppH5JSSDK from '@i61/app-h5-jssdk'
import { browser } from '@/utils/browser'
import { throttle } from '@/utils'

export default {
  name: 'ShareLanding',
  components: {
    UserInfo,
    PurchaseCourse,
    JoinCompetition,
    VideoPlayer,
    Rules
  },
  imgObj: {
    guidance: require('paintingCompetition/assets/personalHomepage/guidance.gif'), // 赛事指导
    btn4: require('paintingCompetition/assets/personalHomepage/btn4.png'), // 为TA加人气
    videoBg: require('paintingCompetition/assets/personalHomepage/video_bg.png'), // video框
    showLike: require('paintingCompetition/assets/common/showLike.gif') // +1 动效
  },
  data() {
    return {
      // 别人查看数据
      otherViewInfoVo: {
        auditState: 0, // 审核状态
        competitionNo: '', // 编号
        likeNum: 0, // 人气值
        matchGroup: 0, //	参赛组别 1-幼儿组 2-少儿组
        name: '', // 姓名
        province: '', // 省份
        rank: 1, // 个人人气榜
        schoolName: '', // 学校
        video: '', // 视频
        workName: '', // 作品名
        workUrl: '', // 图片url
        matchInfoId: '' // 参赛id
      },
      showPurchaseCourse: false, // 抢课弹窗
      showJoinCompetition: false, // 参赛弹窗
      showLike: false,

      autoDisplay: false
    }
  },
  computed: {
    ...mapState(['worksUserId', 'uukey', 'originUserId', 'basicData', 'ownerUserInfo'])
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      overlay: true,
      loadingType: 'spinner'
    })
    this.initData()
    this.buryPoint()
  },
  methods: {
    // 初始化数据
    initData() {
      const { worksUserId } = this.$route.query
      getPersonIndex({
        isSelf: 0,
        userId: worksUserId || this.worksUserId
      })
        .then(res => {
          this.otherViewInfoVo = res.data.otherViewInfoVo
          if (this.otherViewInfoVo.auditState === 1) {
            return this.$toast.clear()
          }
          this.fancyRouterPush(HOME_ROUTE)
        })
        .catch(err => {
          console.error(err)
        })
    },

    // 赛事指导
    guidance() {
      this.fancyRouterPush(COMPETITION_GUIDE_ROUTE)
    },

    // 显示大赛详情
    onShow() {
      this.$refs.rule.onShow()
    },

    // 为ta加人气
    addPopular: throttle(
      function() {
        if (this.basicData.state !== 1) {
          this.$toast('大赛已结束，感谢您的鼓励！')
          return
        }
        const likeSource = Number(browser.versions.weixin) || (AppH5JSSDK.getIsHualalaApp() ? 2 : 0)
        let likeDistinctId = ''
        switch (likeSource) {
          case 0:
            likeDistinctId = localStorage.getItem('deviceId')
            break
          case 1:
            likeDistinctId = window.localStorage.getItem('openId')
            break
          case 2:
            likeDistinctId = this.ownerUserInfo.userId
            break
          default:
            likeDistinctId = localStorage.getItem('deviceId')
        }
        const params = {
          likeDistinctId,
          likeSource,
          matchInfoId: this.otherViewInfoVo.matchInfoId || '' // 参赛id
        }
        giveLike(params).then(res => {
          if (!res.data) {
            this.showPopup()
            this.$toast({
              message: '已收到你的鼓励！快帮我分享给其他好友，一起来参赛吧~',
              className: 'toast',
              getContainer: '.page'
            })
            return
          }
          this.addPopularAnimat()
          this.initData()
        })
      },
      1000,
      true,
      true
    ),

    showPopup() {
      // 如果未报名体验课，弹出体验课报名弹窗
      if (this.basicData.isExperience === 0) {
        this.showPurchaseCourse = true
        this.recordLog({
          eventName: 'PaintChina_leads_pop',
          properties: {
            eventId: '体验课转化弹窗',
            label: '体验课转化弹窗'
          }
        })
      } else if (this.basicData.isCompetition === 0 && this.basicData.state === 1) {
        // 如果未参赛，弹出“我要参赛”弹窗
        this.showJoinCompetition = true
        this.recordLog({
          eventName: 'PaintChina_participate_pop',
          properties: {
            eventId: '我要参赛弹窗',
            label: '我要参赛弹窗'
          }
        })
      }
    },

    // 限时0元抢课
    purchaseCourse() {
      // 前往0元旧体验课落地页
      const url =
        process.env.OLD_EXPERIENCE_URL +
        `&actvityType=${ACTIVITY_TYPE}&uukey=${this.uukey}&originUserId=${this.originUserId}`
      window.location.href = url
    },

    // 关闭抢课弹窗
    closePurchaseCourse() {
      this.showPurchaseCourse = false
      if (this.basicData.isCompetition === 0 && this.basicData.state === 1) {
        // 如果未参赛，弹出“我要参赛”弹窗
        this.showJoinCompetition = true
        this.recordLog({
          eventName: 'PaintChina_participate_pop',
          properties: {
            eventId: '我要参赛弹窗',
            label: '我要参赛弹窗'
          }
        })
      }
    },

    // 加人气
    addPopularAnimat() {
      this.showLike = true
      setTimeout(() => {
        this.showLike = false
      }, 1000)
    },

    // 参赛
    joinMatch() {
      this.fancyRouterPush(PERSON_INFO_ROUTE)
    },

    buryPoint() {
      this.recordLog({
        eventName: 'PaintChina_Works_NonPerson_page',
        properties: {
          eventId: '个人主页',
          label: '显示个人主页（非本人)'
        }
      })
    }
  },
  filters: {
    formatRank(data) {
      if (data === -1) return '10000+'
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
